import {useEffect, useState} from 'react';
import {reportServices} from '../../service/reportService';

export default function useDashboardReport({groupBy, metric, from, to, timezone, currencyCode, workspace, enabled, refreshVersion}) {
    const [report, setReport] = useState({data: null, error: ''});
    useEffect(() => {
        let active = true;
        setReport({data: null, error: ''});
        if (!enabled || workspace === null) return;
        const filters = {from, to, timezone, currencyCode, workspace};
        const request = groupBy === 'day'
            ? reportServices.getChartData({...filters, groupBy})
            : reportServices.getTopReport({...filters, groupBy, metric});
        request.then(data => {
            if (active) setReport({data, error: ''});
        }).catch(error => {
            if (active) setReport({data: null, error: error?.response?.data?.error || 'Unable to load this report. Try refreshing the dashboard.'});
        });
        return () => {active = false;};
    }, [groupBy, metric, from, to, timezone, currencyCode, workspace, enabled, refreshVersion]);
    return report;
}
